// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"8f0dd0af","205":"c74b1033","339":"79f4493d","358":"53819135","484":"1ab3ac05","508":"7dd771b7","551":"cdc243e9","640":"08312eec","672":"e4c84ab9","828":"32574c65","842":"83506446","869":"8e9048bf","974":"2ea8dc15"}[chunkId] + ".chunk.js";
};